import SelectDOAC from "../../../../src/client/katnh/widgets/SelectDOAC.js";
import * as React from 'react';
export default {
  SelectDOAC,
  React
};